import React, {useEffect} from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {CheckCircleOutline} from '@mui/icons-material';
import SecondaryButton from '../../../common/StyledComponents/SecondaryButton';
import PrimaryButton from '../../../common/StyledComponents/PrimaryButton';
import {useHistory} from 'react-router-dom';
import moment from 'moment';
import {useSetRecoilState} from 'recoil';
import {aboutReferralsDialogOpenState} from '../../../recoil/dialogs/DialogsRecoil';
import {theme} from '../../../Theme';
import StandardDialog from '../../../common/StyledComponents/StandardDialog';

const features = [
  {
    title: 'Custom Website Address',
    description: 'Get a custom web domain thats links to your profile:',
  },
  {
    title: 'Bid Ranges',
    description:
      'View the highest, lowest, and average bid placed so far on open jobs.',
  },
  {
    title: 'Unlimited Use',
    description:
      'Get unlimited Site Visits Requests, Bids, and Questions to homeowners.',
  },
];

export default function RecurringUpgradePrompt(props: $TSFixMe) {
  const history = useHistory();
  const setAboutReferralsOpen = useSetRecoilState(
    aboutReferralsDialogOpenState,
  );

  useEffect(() => {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Moment' is not assignable to par... Remove this comment to see the full error message
    localStorage.setItem('bidmiiProUpgradeShown', moment().add(1, 'month'));
  }, []);

  return (
    <StandardDialog
      open={true}
      onClose={props.handleClose}
      secondaryAction={
        <SecondaryButton
          onClick={() => {
            history.push('/bidmii-pro');
            props.handleClose();
          }}>
          LEARN MORE
        </SecondaryButton>
      }
      primaryAction={
        <PrimaryButton
          onClick={() => {
            history.push('/bidmii-pro/plans');
            props.handleClose();
          }}
          color={theme.palette.blue.main}>
          UPGRADE
        </PrimaryButton>
      }>
      <div>
        <Typography
          variant="body1"
          gutterBottom
          style={{fontSize: 22, lineHeight: 1.3}}>
          Upgrade to Bidmii Pro and grow your business faster.
        </Typography>
        <Grid container alignItems="center" style={{margin: '16px 0'}}>
          <Typography variant="h6">🎉&nbsp;&nbsp;&nbsp;</Typography>
          <Typography
            variant="subtitle1"
            style={{
              color: theme.palette.blue.dark,
              fontSize: 13,
              lineHeight: 1.3,
              width: '80%',
            }}>
            For a limited time, get free months of Bidmii Pro when you refer
            other contractors.
            <Button
              onClick={() => {
                // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean' is not assignable to pa... Remove this comment to see the full error message
                setAboutReferralsOpen(true);
                props.handleClose();
              }}
              style={{
                fontSize: 13,
                marginLeft: 8,
                color: theme.palette.blue.dark,
                borderBottom: `1px solid ${theme.palette.blue.dark}`,
                borderRadius: 0,
                lineHeight: '16px',
                padding: 0,
              }}>
              LEARN MORE
            </Button>
          </Typography>
        </Grid>
        <Typography variant="subtitle1">THESE FEATURES AND MORE</Typography>
        {features.map((feature, i) => (
          <Grid container style={{marginBottom: 16}} key={i}>
            <CheckCircleOutline
              style={{color: theme.palette.green.main, marginRight: 8}}
            />
            <Grid item xs={10} sm={9}>
              <Typography variant="subtitle1" style={{fontWeight: 'bold'}}>
                {feature.title}
              </Typography>
              <Typography variant="subtitle2">
                {feature.description}
                {i === 0 && (
                  <span style={{color: theme.palette.gray.text}}>
                    {' '}
                    www."mybusiness".com
                  </span>
                )}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </div>
    </StandardDialog>
  );
}
